<template>
  <div class="question-container">
    <div v-if="mode == 0">
      <div class="row">
        <div v-if="showTitle" class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question && question.isSkippable">Optional</span>
        </div>

        <div v-if="preventPIIAccessFromRoles" :class="showTitle ? 'col-md-7' : 'col-md-12'">
          <template v-if="answer && answer.answerText">
            <div v-for="(video, index) in parsedAns" :key="`rec-video-${index}-${answer.questionId}`" style="width:100%">
              <div v-if="video.isTextEnable">
                <p>{{ video.text }}</p>
              </div>
              <div v-else class="d-flex align-items-center mb-15">
                <div class="position-relative video-thumbnail p-0">
                  <div>
                    <img @contextmenu.prevent :src="video.thumbnailPresignedURL" height="100px" alt="" />
                    <a @click="refreshVideoContent(video, answer.questionId, index)" id="video-play" class="cursor-pointer" :data-target="`#${getId(video.name, answer.questionId, index)}`" data-toggle="modal"><img @contextmenu.prevent src="static/img/activity-configurator/audio-recording-media-play.png" alt=""/></a>
                  </div>
                  <div class="modal fade" :id="getId(video.name, answer.questionId, index)" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <button @click="stopVideo(video, answer.questionId, index)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <video :id="getId(video.name, answer.questionId, index) + '-video'" width="400" height="704" controls controlsList="nodownload" @contextmenu.prevent>
                            <source :src="video.presignedURL" type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-0 ml-18">
                  <p class="ml-10 mt-10">
                    <b>{{ video.name }} - {{ video.time }}</b>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          <template v-if="answer && answer.answerText">
            <div>
              <p v-for="(fileName, idx) in answer.answerText.split(',')" :key="idx">{{ fileName }}</p>
              <p>{{ new Date(answer.startTime) | formatGMTDate }}</p>
            </div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question && question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question && question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>

        <div class="col-md-7" v-if="preventPIIAccessFromRoles" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <template v-if="answer && answer.answerText">
            <div v-for="(video, index) in parsedAns" :key="index" style="width:100%">
              <div v-if="video.isTextEnable">
                <p>{{ video.text }}</p>
              </div>
              <div v-else class="d-flex align-items-center mb-15">
                <div class="position-relative video-thumbnail p-0">
                  <div>
                    <img @contextmenu.prevent :src="video.thumbnailPresignedURL" height="100px" alt="" />
                    <a @click="refreshVideoContent(video, answer.questionId, index)" id="video-play" class="cursor-pointer" :data-target="`#${getId(video.name, answer.questionId, index)}-edit`" data-toggle="modal"><img @contextmenu.prevent src="static/img/activity-configurator/audio-recording-media-play.png" alt=""/></a>
                  </div>
                  <div class="modal fade" :id="`${getId(video.name, answer.questionId, index)}-edit`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <video :id="getId(video.name, answer.questionId, index) + '-video'" width="400" height="704" controls controlsList="nodownload" @contextmenu.prevent>
                            <source :src="video.presignedURL" type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="p-0 ml-18">
                  <p class="ml-10 mt-10">
                    <b>{{ video.name }} - {{ video.time }}</b>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          <template v-if="answer && answer.answerText">
            <div>
              <p v-for="(fileName, idx) in answer.answerText.split(',')" :key="idx">{{ fileName }}</p>
              <p>{{ new Date(answer.startTime) | formatGMTDate }}</p>
            </div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question && question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question && question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <div v-if="preventPIIAccessFromRoles">
              <div class="col-md-12 pl-30">
                <template v-if="answer && answer.answer_text">
                  <div v-for="(video, index) in parsedAns" :key="index" style="width:100%">
                    <div v-if="video.isTextEnable">
                      <p>{{ video.text }}</p>
                    </div>
                    <div v-else class="d-flex align-items-center mb-15">
                      <div class="position-relative video-thumbnail p-0">
                        <div>
                          <img @contextmenu.prevent :src="video.thumbnailPresignedURL" height="100px" alt="" />
                          <a @click="refreshVideoContent(video, answer.questionId, index)" id="video-play" class="cursor-pointer" :data-target="`#${getId(video.name, answer.question_id, index)}-history`" data-toggle="modal"><img @contextmenu.prevent src="static/img/activity-configurator/audio-recording-media-play.png" alt=""/></a>
                        </div>
                        <div class="modal fade" :id="`${getId(video.name, answer.question_id, index)}-history`" tabindex="-1" role="dialog" aria-labelledby="ImageModalCenterTitle" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">CLOSE <i class="fa fa-times"></i></span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <video :id="getId(video.name, answer.questionId, index) + '-video'" width="400" height="704" controls controlsList="nodownload" @contextmenu.prevent>
                                  <source :src="video.presignedURL" type="video/mp4" />
                                </video>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="p-0 ml-18">
                        <p class="ml-10 mt-10">
                          <b>{{ video.name }} - {{ video.time }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <template v-if="answer && answer.answer_text">
                <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label class="fs-12">Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </template>
              <template v-else-if="question && question.isSkippable">
                <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                  <label class="fs-12">Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ question.skipScore || 0 }}
                  </div>
                </div>
              </template>
            </div>
            <div v-else>
              <template v-if="answer && answer.answer_text">
                <div>
                  <p v-for="(fileName, idx) in answer.answer_text.split(',')" :key="idx">{{ fileName }}</p>
                  <p>{{ new Date(answer.start_time) | formatGMTDate }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1"></div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import { BSTAT, CRA, DM, HOME_HEALTH, PHV, PI, QUALITY, STUDY_ADMIN, STUDY_MANAGER, SYSTEM_ADMIN, CraUB, SUPPORT } from "@/constants/authRoles";
export default {
  name: "VideoRecordingResponse",
  mixins: [activityCommonMixin],
  data() {
    return {};
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    usage: Object,
    surveyData: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    showTitle: {
      type: Boolean,
      default: true
    },
    activityType: String
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    preventPIIAccessFromRoles() {
      let roles = this.canSysAdminAccess || this.canStudyAdminAccess || this.canStudyManagerAccess || this.canCraAccess || this.canDmAccess || this.canQualityAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess || this.canCraUBAccess || this.canSupportAccess;
      return !roles;
    },
    parsedAns() {
      if (this.answer) {
        return JSON.parse(this.answer[this.JsonFieldToDisplay()]);
      }
      return [];
    }
  },
  methods: {
    refreshVideoContent(videoJson, id, index) {
      let video_el = document.getElementById(this.getId(videoJson.name, id, index) + "-video"); // get reference
      video_el.src = videoJson.presignedURL; // change src
      video_el.load();
    },
    stopVideo(videoJson, id, index) {
      let video_el = document.getElementById(this.getId(videoJson.name, id, index) + "-video"); // get reference
      video_el.pause();
    },
    getId(name, id, index) {
      let revisedName = name.replace(" ", "");
      return `${id}-${index}-${revisedName}`;
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.cursor-pointer {
  cursor: pointer;
}

#video-play {
  position: absolute;
  top: 30px;
  left: 6px;
}

.video-thumbnail {
  min-width: 55px;
  width: auto;
}
</style>
